module.exports = __webpack_public_path__ + "static/media/solution15.35437487.png";